import { useContext } from 'react';
import { NavigationComponentContext } from '../components/internal';
export const useNavComponentManager = () => {
  const manager = useContext(NavigationComponentContext);
  if (!manager) {
    throw new Error('Navigation Component Manager not found. Is your component wrapped in `NavigationComponent`?');
  }
  return manager;
};